import { defineAsyncComponent } from "vue";

// @vuepic/vue-datepicker (+ @floating-ui/*, Teile von date-fns) ist der grösste einzelne
// Bundle-Beitrag (~18%), wird aber nur gebraucht, sobald ein Wishdate-Feld sichtbar ist.
// Alle Konsumenten importieren denselben dynamischen import() -> nur ein gemeinsamer Chunk,
// unabhängig davon, welche Komponente ihn zuerst anfordert.
export default defineAsyncComponent(() =>
  import("@vuepic/vue-datepicker").then((m) => m.VueDatePicker),
);
